<template>
  <div class="icon">
    <!-- fb -->
    <svg
      v-if="social === 'fb'"
      width="13"
      height="26"
      viewBox="0 0 13 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.62025 12.8881V26H7.97772V12.8815H11.6111L12.1575 8.66228H7.97772V5.97671C7.97772 4.75899 8.32 3.92962 10.0643 3.92962H12.2759V0.164557C11.8942 0.111899 10.5711 0 9.03089 0C5.81873 0 3.62025 1.96152 3.62025 5.56203V8.66886H0V12.8881H3.62025Z"
        fill="currentColor"
      />
    </svg>

    <!-- vk -->
    <svg
      v-if="social === 'vk'"
      width="26"
      height="15"
      viewBox="0 0 26 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.7901 9.10956C22.629 9.929 23.5166 10.7002 24.2697 11.6043C24.6034 12.0043 24.9179 12.4179 25.1573 12.883C25.4991 13.5463 25.1905 14.2737 24.5968 14.3131L20.9091 14.3123C19.9567 14.3912 19.1988 14.007 18.5598 13.3559C18.0497 12.837 17.5765 12.2827 17.0852 11.7461C16.8845 11.5259 16.6731 11.3185 16.4212 11.1554C15.9185 10.8284 15.4817 10.9285 15.1937 11.4537C14.9002 11.9881 14.8331 12.5803 14.8051 13.1751C14.765 14.0446 14.5028 14.2718 13.6303 14.3127C11.766 14.4 9.99716 14.1172 8.35313 13.1773C6.90282 12.3483 5.78029 11.1782 4.80212 9.8535C2.89734 7.27108 1.43856 4.43675 0.127825 1.52102C-0.167172 0.864368 0.0486441 0.513023 0.773063 0.499396C1.97662 0.476194 3.18018 0.47914 4.38374 0.498291C4.87356 0.506025 5.19766 0.786293 5.38585 1.24849C6.03624 2.8487 6.83359 4.37119 7.83275 5.7832C8.09902 6.15922 8.37081 6.53414 8.75788 6.79967C9.18509 7.09283 9.51066 6.99597 9.71211 6.51904C9.84101 6.21594 9.89662 5.89185 9.92461 5.56702C10.0204 4.45443 10.0318 3.3422 9.86606 2.23403C9.76294 1.54054 9.37292 1.09271 8.68165 0.961596C8.32956 0.894936 8.38112 0.764563 8.55238 0.563478C8.84958 0.215816 9.12801 0.000736237 9.68449 0.000736237L13.8509 0C14.5076 0.1289 14.6549 0.42353 14.744 1.08497L14.7477 5.71507C14.74 5.97103 14.8762 6.7297 15.3358 6.89727C15.7041 7.0188 15.9472 6.72344 16.1674 6.49031C17.1666 5.43002 17.8785 4.17858 18.516 2.88332C18.7974 2.3121 19.0401 1.721 19.2758 1.1288C19.4511 0.690906 19.7236 0.475458 20.2178 0.482823L24.23 0.487612C24.3482 0.487612 24.4682 0.488716 24.5854 0.508972C25.2615 0.624614 25.4468 0.91556 25.2376 1.57516C24.9083 2.61152 24.2686 3.47478 23.6433 4.34025C22.973 5.26686 22.2582 6.16106 21.5945 7.09172C20.9846 7.94246 21.0329 8.37078 21.7901 9.10956Z"
        fill="currentColor"
      />
    </svg>

    <!-- ok -->
    <svg
      v-if="social === 'ok'"
      width="14"
      height="24"
      viewBox="0 0 14 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.951 3.63052C8.36571 3.63052 9.51623 4.78104 9.51623 6.19575C9.51623 7.6062 8.36571 8.75671 6.951 8.75671C5.53629 8.75671 4.38577 7.6062 4.38577 6.19575C4.38577 4.78104 5.53629 3.63052 6.951 3.63052ZM6.951 12.3872C10.3685 12.3872 13.1467 9.60895 13.1467 6.19575C13.1467 2.77829 10.3685 0 6.951 0C3.53354 0 0.759513 2.77829 0.759513 6.19575C0.759513 9.60895 3.53354 12.3872 6.951 12.3872ZM9.45657 17.441C10.7179 17.1512 11.9323 16.6527 13.053 15.9496C13.901 15.4169 14.1566 14.2962 13.624 13.4483C13.0871 12.596 11.9707 12.3404 11.1184 12.8773C8.58303 14.4709 5.31897 14.4709 2.77931 12.8773C1.93134 12.3404 0.810648 12.596 0.278002 13.4483C-0.254646 14.2962 0.00102414 15.4169 0.848998 15.9496C1.96969 16.6527 3.18412 17.1512 4.44543 17.441L0.981094 20.9011C0.273739 21.6084 0.273739 22.7589 0.981094 23.4663C1.33903 23.82 1.79924 23.9989 2.26371 23.9989C2.72818 23.9989 3.19265 23.82 3.55058 23.4663L6.951 20.0659L10.3557 23.4663C11.063 24.1779 12.2093 24.1779 12.9209 23.4663C13.6283 22.7589 13.6283 21.6084 12.9209 20.9011L9.45657 17.441Z"
        fill="currentColor"
      />
    </svg>

    <!-- li -->
    <svg
      v-if="social === 'li'"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.28571 5.74627V19.3177H0V5.74627H4.28571ZM0 1.79627C0 0.796268 0.857143 0.0319824 2.14286 0.0319824C3.42857 0.0319824 4.23571 0.796268 4.28571 1.79627C4.28571 2.79627 3.48571 3.60341 2.14286 3.60341C0.857143 3.60341 0 2.79627 0 1.79627ZM20 19.3177H15.7143C15.7143 19.3177 15.7143 12.7034 15.7143 12.1748C15.7143 10.7463 15 9.3177 13.2143 9.28912H13.1571C11.4286 9.28912 10.7143 10.7606 10.7143 12.1748C10.7143 12.8248 10.7143 19.3177 10.7143 19.3177H6.42857V5.74627H10.7143V7.57484C10.7143 7.57484 12.0929 5.74627 14.8643 5.74627C17.7 5.74627 20 7.69627 20 11.6463V19.3177Z"
        fill="currentColor"
      />
    </svg>

    <!-- in -->
    <svg
      v-if="social === 'in'"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.4224 18.2053C21.6943 17.5055 21.8804 16.7061 21.9336 15.5351C21.9874 14.3621 22 13.9874 22 11C22 8.01265 21.9874 7.63791 21.9339 6.4649C21.8804 5.29393 21.6945 4.49447 21.4224 3.7947C21.1465 3.06072 20.7133 2.39602 20.1538 1.84649C19.6043 1.28672 18.9393 0.853529 18.2053 0.577301C17.5055 0.30575 16.7061 0.119845 15.5351 0.0666454C14.3621 0.0128614 13.9873 0 11 0C8.01265 0 7.63791 0.0128614 6.4649 0.0663531C5.29393 0.119845 4.49447 0.30575 3.7947 0.577594C3.06072 0.853821 2.39573 1.28672 1.84649 1.84649C1.28672 2.39573 0.853529 3.06072 0.577301 3.7947C0.305458 4.49447 0.119552 5.29393 0.0663531 6.4649C0.0125691 7.63791 0 8.01265 0 11C0 13.9874 0.0125691 14.3621 0.0666454 15.5354C0.119845 16.7061 0.306042 17.5058 0.577886 18.2053C0.854113 18.9393 1.28702 19.6043 1.84649 20.1535C2.39602 20.7133 3.06072 21.1462 3.79499 21.4224C4.49447 21.6943 5.29422 21.8802 6.4649 21.9336C7.63821 21.9871 8.01265 22 11.0003 22C13.9876 22 14.3624 21.9871 15.5354 21.9336C16.7061 21.8802 17.5058 21.6943 18.2053 21.4224C19.6829 20.851 20.851 19.6829 21.4224 18.2053ZM18.8989 3.24776C19.2643 3.60262 19.5455 4.03494 19.7217 4.51256C19.8725 4.90016 20.0517 5.48272 20.1005 6.55519C20.1534 7.71505 20.1646 8.06289 20.1646 11.0003C20.1646 13.9373 20.1534 14.2852 20.1005 15.4453C20.0514 16.5178 19.8722 17.1001 19.7217 17.4877C19.3517 18.447 18.5934 19.2052 17.6341 19.5753C17.2465 19.7261 16.6639 19.9053 15.5915 19.9541C14.4319 20.007 14.084 20.0181 11.1464 20.0181C8.20901 20.0181 7.86146 20.007 6.7016 19.9541C5.62913 19.9053 5.04657 19.7261 4.65897 19.5753C4.18106 19.399 3.74903 19.1178 3.39417 18.7525C3.02879 18.3976 2.74789 17.9656 2.57134 17.4877C2.4208 17.1001 2.24162 16.5178 2.1928 15.4453C2.1399 14.2852 2.1285 13.9373 2.1285 11.0003C2.1285 8.06289 2.1399 7.71505 2.1928 6.55519C2.24162 5.48272 2.4208 4.90016 2.57134 4.51256C2.74789 4.03465 3.02909 3.60262 3.39447 3.24776C3.74903 2.88238 4.18135 2.60118 4.65927 2.42493C5.04657 2.27439 5.62913 2.09521 6.7016 2.0461C7.86146 1.99319 8.2093 1.98208 11.1467 1.98208C14.0837 1.98208 14.4316 1.99348 15.5917 2.04639C16.6642 2.09521 17.2465 2.27439 17.6341 2.42493C18.112 2.60118 18.544 2.88238 18.8989 3.24776Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.23809 11C5.23809 14.1824 7.81782 16.7619 11.0001 16.7619C14.1822 16.7619 16.7619 14.1824 16.7619 11C16.7619 7.81759 14.1822 5.23809 11.0001 5.23809C7.81782 5.23809 5.23809 7.81759 5.23809 11ZM11 14.6667C13.0251 14.6667 14.6667 13.0251 14.6667 11C14.6667 8.97491 13.0251 7.33333 11 7.33333C8.97491 7.33333 7.33333 8.97491 7.33333 11C7.33333 13.0251 8.97491 14.6667 11 14.6667Z"
        fill="currentColor"
      />
      <path
        d="M16.7619 6.28571C16.1833 6.28571 15.7143 5.81665 15.7143 5.23809C15.7143 4.65954 16.1833 4.19048 16.7619 4.19048C17.3405 4.19048 17.8095 4.65954 17.8095 5.23809C17.8093 5.81665 17.3405 6.28571 16.7619 6.28571Z"
        fill="currentColor"
      />
    </svg>

    <!-- tt -->
    <svg
      v-if="social === 'tt'"
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5661 8.9008C19.3812 8.91727 19.1938 8.92824 19.0039 8.92824C16.8667 8.92824 14.9885 7.8708 13.8959 6.2725C13.8959 10.4654 13.8959 15.236 13.8959 15.316C13.8959 19.0072 10.7849 22 6.94793 22C3.11096 22 0 19.0072 0 15.316C0 11.6247 3.11096 8.63194 6.94793 8.63194C7.09296 8.63194 7.23474 8.64448 7.37733 8.6531V11.9469C7.23474 11.9304 7.09459 11.9054 6.94793 11.9054C4.98911 11.9054 3.40185 13.4323 3.40185 15.3168C3.40185 17.2012 4.98911 18.7281 6.94793 18.7281C8.90674 18.7281 10.6366 17.2435 10.6366 15.3591C10.6366 15.2846 10.6708 0 10.6708 0H13.9431C14.2511 2.81486 16.6133 5.03634 19.5661 5.24015V8.9008Z"
        fill="currentColor"
      />
    </svg>

    <!-- yt -->
    <svg
      v-if="social === 'yt'"
      width="23"
      height="16"
      viewBox="0 0 23 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.0317 13.3042C22.4948 11.5439 22.4948 7.8934 22.4948 7.8934C22.4948 7.8934 22.5135 4.22479 22.0317 2.46451C21.7722 1.50101 21.0125 0.741028 20.049 0.48175C18.2887 0 11.2475 0 11.2475 0C11.2475 0 4.20639 0 2.44611 0.463348C1.50101 0.722626 0.722626 1.50101 0.463348 2.46451C0 4.22479 0 7.875 0 7.875C0 7.875 0 11.5439 0.463348 13.2855C0.7229 14.249 1.4826 15.009 2.44611 15.2682C4.22479 15.75 11.2475 15.75 11.2475 15.75C11.2475 15.75 18.2887 15.75 20.049 15.2867C21.0125 15.0274 21.7722 14.2677 22.0317 13.3042ZM14.8552 7.87494L9 11.2472V4.50269L14.8552 7.87494Z"
        fill="currentColor"
      />
    </svg>
  </div>
</template>

<script>
export default {
  props: ["social"],
};
</script>

